<template>
  <div class="flex ticket" :class="type">
    <div class="right-side dFlex">
      <slot name="ticket-right"></slot>
    </div>
    <div class="left-side p-relative">
      <slot name="ticket-left"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "ClubContainer",
  props: ["type"],
};
</script>
<style scoped>
.ticket {
  width: 100%;
  margin: 0 auto;
  min-height: 150px;
  border-radius: 10px;
  overflow: hidden;
  margin: 10px auto;
}

.right-side {
  width: 35%;
  border-left: 1px solid #ddd;
  position: relative;
  box-shadow: rgba(172, 176, 179, 0.2) 0 0 4px 1px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  margin: 2px;
  margin-left: 0;
  flex-direction: column;
  padding: 10px 5px;
}
.left-side {
  width: 65%;
  box-shadow: rgba(172, 176, 179, 0.2) 0 0 4px 1px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  border-right: none;
  margin: 2px;
  margin-right: 0;
}
.right-side:before {
  content: "";
  display: block;
  position: absolute;
  top: -12px;
  left: -14px;
  z-index: 1;
  width: 25px;
  height: 25px;
  background-color: #fff;
  border-bottom-left-radius: 110px;
  border-bottom-right-radius: 110px;
  border-bottom: 0;
  box-shadow: rgba(172, 176, 179, 0.2) 0 0 4px 1px;
}

.right-side:after {
  content: "";
  display: block;
  position: absolute;
  bottom: -12px;
  left: -14px;
  z-index: 1;
  width: 25px;
  height: 25px;
  background-color: #fff;
  border-top-left-radius: 110px;
  border-top-right-radius: 110px;
  border-bottom: 0;
  box-shadow: rgba(172, 176, 179, 0.2) 0 0 4px 1px;
}
</style>